import React from 'react';
import { Col } from 'reactstrap';

import PropTypes from 'prop-types';

const CartProductAlerts = ({ alerts }) => {
  return (
    <Col xs={12} className="CartProductAlerts">
      {alerts}
    </Col>
  );
};

CartProductAlerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default CartProductAlerts;
